import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=62fb0532&scoped=true"
import script from "./ModalRegister.vue?vue&type=script&lang=js"
export * from "./ModalRegister.vue?vue&type=script&lang=js"
import style0 from "./ModalRegister.vue?vue&type=style&index=0&id=62fb0532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb0532",
  null
  
)

export default component.exports